import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { Trans } from 'react-i18next';

const theme = createDSTheme();

export function SuperChangeDescription({ keptSuper, lostSuper }: { keptSuper: boolean; lostSuper: boolean }) {
  const descriptionKey = lostSuper
    ? 'description.lostSuper'
    : keptSuper
      ? 'description.keptSuper'
      : 'description.isNowSuper';

  return (
    <Text
      flex={1}
      fontSize={lostSuper ? 16 : 20}
      style={{
        textAlign: lostSuper ? 'left' : 'center',
        marginVertical: lostSuper ? 0 : theme.spacing['spacing.general.x4'],
      }}
      width="100%"
    >
      <Trans
        components={{ strong: <Text fontWeight="700" /> }}
        i18nKey={descriptionKey}
        ns="superPartageurNotification"
      />
    </Text>
  );
}
